import type { GlobalEvents, QBusEventEnum } from "@otto-ec/global-resources";

/**
 *
 */
export const globalEvents = window.o_global.events<GlobalEvents>();

/*       */
/*                                                   */
/**
 *
 *
 */
export type TrackingDataContainer = Record<string, unknown>;

export type TrackingCreateContextParams = [
  /**
 *
 *
 *
 */
  id: string,
  /**
 *
 *
 */
  url: string,
  /*                                   */
  dataContainer?: TrackingDataContainer
];

type TrackingSubmitEventParams = [
  /**
 *
 */
  dataContainer?: TrackingDataContainer,
  /**
 *
 *
 */
  eventMergeId?: string | null
];

/**
 *
 */
export type TrackingEvents = {
  /**
 *
 *
 *
 */
  "tracking.bct.createContext": TrackingCreateContextParams;
  /**
 *
 */
  "tracking.bct.closeContext": [];
  /**
 *
 *
 */
  "tracking.bct.replaceContext": TrackingCreateContextParams;
  /**
 *
 */
  "tracking.bct.submitEvent": TrackingSubmitEventParams;
};

export const trackingEvents = window.o_global.events<TrackingEvents>();

export const TRACKING_EVENTS: QBusEventEnum<TrackingEvents> = {
  closeContext: "tracking.bct.closeContext",
  createContext: "tracking.bct.createContext",
  replaceContext: "tracking.bct.replaceContext",
  submitEvent: "tracking.bct.submitEvent",
};
